import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const create = ({ commit }, values) => {
  commit(types.EXSBPERIODTYPE_CREATE_SET_ERROR, '')
  commit(types.EXSBPERIODTYPE_CREATE_TOGGLE_LOADING)

  return fetch('e_x_s_b_period_types', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => {
      commit(types.EXSBPERIODTYPE_CREATE_TOGGLE_LOADING)

      return response.json()
    })
    .then((data) => {
      commit(types.EXSBPERIODTYPE_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      commit(types.EXSBPERIODTYPE_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.EXSBPERIODTYPE_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.EXSBPERIODTYPE_CREATE_SET_ERROR, e.errors._error)
        return
      }

      commit(types.EXSBPERIODTYPE_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.EXSBPERIODTYPE_CREATE_RESET)
}
